export var getErrorMessage = function (data) {
    if (!(data instanceof Object)) {
        return '';
    }
    if ('message' in data && typeof data.message === 'string') {
        return data.message;
    }
    return '';
};
